export default {
  firstname: {
    presence: { allowEmpty: false, message: 'is required' }
  },
  lastname: {
    presence: { allowEmpty: false, message: 'is required' }
  }
};
